import { ControlValueAccessor, NG_VALUE_ACCESSOR, FormGroup, FormBuilder,  } from '@angular/forms';
import { PatientSearch } from '../../../model/patient/patient-search';
import { PatientService } from '../../../services/patient.service';
import { NotificationToastService } from '../../../services/notification-toast.service';
import { switchMap, map, filter, debounceTime, tap, switchAll, finalize } from 'rxjs/operators';
import { Component, ElementRef, forwardRef, OnInit, ViewChild } from '@angular/core';


export const PATIENT_AUTOCOMPLETE_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => PatientAutoCompleteComponent),
  multi: true,
};

@Component({
  selector: 'patient-autocomplete',
  providers: [PATIENT_AUTOCOMPLETE_VALUE_ACCESSOR],
  templateUrl: './patient-autocomplete.component.html',
  styleUrls: ['./patient-autocomplete.component.css']
})
export class PatientAutoCompleteComponent implements OnInit, ControlValueAccessor {

  onChange;
  form: FormGroup;
  patients: PatientSearch[] = [];
  selecting: boolean;
  loading: boolean;
  @ViewChild('patientCtrl', {static: false}) patientCtrl: ElementRef;


  constructor(private formBuilder: FormBuilder, private patientService: PatientService
    , private notificationToastService: NotificationToastService) {
    this.form = this.formBuilder.group({
      PatientCtrl: [null]
    });
  }

  get f() { return this.form.controls; }

  displayFn(item?: PatientSearch): string | undefined {
    return item ? item.LastName + ', ' + item.FirstName : undefined;
  }

  getProfilePatientPath(item: PatientSearch): string {
    return 'http://localhost:5000/Content/Images/profile_patient.png';
  }

  ngOnInit() {
    this.f.PatientCtrl.valueChanges.pipe(
      filter(value => {
        if (value != null && value !== '' && typeof value === 'string') {
          return true;
        } else {
          if (value == null || value === '') {
            this.patients = [];
          }
          return false;
        }
      }),
      debounceTime(400),
      tap(() => this.loading = true),
      switchMap(value => this.patientService.getPatientsFromSearch(value)
        .pipe(finalize(() => this.loading = false), ))
    ).subscribe(values => this.patients = values);
  }

  patientSelected(patient: PatientSearch) {
    this.selecting = true;
    this.form.patchValue({ PatientCtrl: patient });
    this.onChange(patient);
  }

  onPatientChange(searchValue: string) {
    this.onChange(null);
  }

  writeValue(obj: any): void {
    this.form.patchValue({ PatientCtrl: obj });
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {

  }
  setDisabledState?(isDisabled: boolean): void {

  }
}
